<template>
  <v-container>
    <p>Edit biz customer</p>
    <v-row>
      <v-col
        cols="12"
        lg="10"
        md="12"
      >
        <v-row>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="biz_customer.company_name"
              label="Company Name"
              :rules="[rules.require]"
              outlined
              dense
            />
          </v-col>
          <v-col
            cols="12"
            md="6"
          >
            <v-text-field
              v-model="biz_customer.remark"
              label="Remark"
              outlined
              dense
            />
          </v-col>
        </v-row>
        <v-divider></v-divider>
        <div class="text-left">
          <v-btn
            class="mx-2"
            small
            color="orange"
            dark
            @click="updateBizCustomer"
          >
            Update
          </v-btn>
          <v-btn
            class="mx-2"
            small
            exact
            :to="{ name: 'biz-customer-list' }"
          >
            Cancel
          </v-btn>
        </div>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { authHeader } from '../../../_helpers';
export default {
  name: "BizCustomerEdit",
  components: { },
  data: () => ({
    biz_customer_id: null,
    biz_customer: {
      company_name: null,
      remark: null
    },
    rules: {
      require: value => !!value || 'Please fill in information',
    },
  }),
  async mounted () {
    let id = this.$route.params.id
    this.getBizCustomer(id)
  },
  methods: {
    async getBizCustomer (id) {
      try {
        this.biz_customer_id = id
        const { data } = await this.$http.get(`/back-office/biz-customers/${this.biz_customer_id}`, authHeader())
        this.biz_customer.company_name = data.company_name
        this.biz_customer.remark = data.remark
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    async updateBizCustomer () {
      try {
        if (this.requireField()) {
          await this.$http.put(`/back-office/biz-customers/${this.biz_customer_id}`, this.biz_customer, authHeader())
          this.$router.push({ name: 'biz-customer-list' })
        }
      } catch (err) {
        console.log(err)
        alert('Something went wrong')
      }
    },
    requireField () {
      if (!this.biz_customer.company_name) {
        alert('Please fill in company name')
        return false
      }
      return true
    },
  },
};
</script>
